import React from 'react';
import {
  dataTableMeasureSetNamedMeasure,
  ICohortRow,
  IRow,
  IRowMeta,
  queryMeasureSetNamedMeasure,
  removeErrorAction,
  RowType,
  setRowPropAction,
} from '../../../../redux/slices/oldBuilder';
import {
  IMeasureFieldsFragment,
  MeasureType,
} from '../../../../utils/apollo/graphqlSchema';
import BuilderMeasureMenu from '../BuilderMeasureMenu';
import { rowSelector } from '../../../../redux/selectors/builder';
import { useAppDispatch, useAppSelector } from '../../../../redux/hooks';
import { parseMeasureToCohortRow } from '../../../../utils/builder/measures/parseMeasureToCohortRow';
import { defaultRow } from '../../../../redux/slices/oldBuilder/defaults';
import * as BuilderUI from '../../BuilderUI';
import { SquareRemoveButton } from '../../../Button';

interface IProps {
  rowMeta: IRowMeta;
  cohortRow: ICohortRow;
  allowRollingControl: boolean;
  allowCompoundMeasure: boolean;
  isCohort: boolean;
}

const NamedMeasureSelector = ({
  rowMeta,
  cohortRow,
  isCohort,
  allowRollingControl,
  allowCompoundMeasure,
}: IProps) => {
  const dispatch = useAppDispatch();

  const currentRow: IRow = useAppSelector((state) =>
    rowSelector(state, rowMeta),
  );
  const { measureId, defaultNamedMeasure } = currentRow;
  const { isCollapsedMeasure } = cohortRow;

  const isDataTable = rowMeta.rowType === RowType.dataTableMeasures;

  const handleSelectNamedMeasure = (measure: IMeasureFieldsFragment) => {
    // clean measure fields errors
    dispatch(removeErrorAction({ rowMeta, errorKey: '', clearRow: true }));

    // Measure cohort condition case
    if (isCohort) {
      const rowFields = parseMeasureToCohortRow(measure);

      dispatch(
        setRowPropAction({
          rowMeta,
          row: rowFields,
        }),
      );

      return;
    }

    if (isDataTable) {
      dispatch(dataTableMeasureSetNamedMeasure({ measure, rowMeta }));
      return;
    }

    dispatch(queryMeasureSetNamedMeasure({ measure, rowMeta }));
  };

  const handleClear = () => {
    dispatch(
      setRowPropAction({
        rowMeta,
        row: defaultRow(),
      }),
    );
  };

  const handleRemove = () => {
    if (measureId) {
      handleClear();
      return;
    }

    dispatch(
      setRowPropAction({
        rowMeta,
        row: {
          showMeasure: false,
        },
      }),
    );
  };

  const handleExpandSimpleMeasure = () => {
    dispatch(
      setRowPropAction({
        rowMeta,
        row: {
          isCollapsedMeasure: false,
        },
      }),
    );
  };

  return (
    <BuilderUI.BuilderFieldContainer>
      <BuilderUI.BuilderFieldLabel>Named Measure</BuilderUI.BuilderFieldLabel>
      <BuilderMeasureMenu
        defaultNamedMeasure={defaultNamedMeasure}
        onChange={handleSelectNamedMeasure}
        onClear={handleClear}
        autoFocus={!measureId}
        allowRollingControl={allowRollingControl}
        allowCompoundMeasure={allowCompoundMeasure}
        onExpand={
          !isDataTable &&
          isCollapsedMeasure &&
          isCohort &&
          cohortRow?.type === MeasureType.Simple
            ? handleExpandSimpleMeasure
            : undefined
        }
      />
      <SquareRemoveButton
        onClick={handleRemove}
        content={'Remove Named Measure'}
      />
    </BuilderUI.BuilderFieldContainer>
  );
};

export default NamedMeasureSelector;
